import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { addAlert } from '../../store/slices/alertReducer'
import * as domainsApi from "../../api/domains";


export const getDomains = createAsyncThunk(
  "domain/getDomains", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await domainsApi.getDomains(source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const getTaskTypesForDomain = createAsyncThunk(
  "domain/getTaskTypesForDomain", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await domainsApi.getTaskTypesForDomain(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const getTaskTypesMotivationsForDomain = createAsyncThunk(
  "domain/getTaskTypesMotivationsForDomain", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      const { domainId, tasktypeId } = params;
      return await domainsApi.getgetTaskTypeMotivationForDomain(domainId, tasktypeId, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);


export const getDomainMembersForDomain = createAsyncThunk(
  "domain/getDomainMembersForDomain", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await domainsApi.getDomainMembersForDomain(params, source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const getWorkgroups = createAsyncThunk(
  "domain/getWorkgroups", async (params, thunkAPI) => {
    try {
      const source = axios.CancelToken.source()
      const { signal } = thunkAPI;
      signal.addEventListener('abort', () => {
        source.cancel()
      })
      return await domainsApi.getWorkgroups(source)
    } catch (error) {
      thunkAPI.dispatch(addAlert(error));
      return thunkAPI.rejectWithValue({ error: error.message  });
    }
  }
);

export const taskSlice = createSlice({
  name: 'domain',
  initialState: {
    domains: [],
    taskTypes: [],
    members: [],
    membersLoading: null,
    workgroups: [],
    workgroupsLoading: null,
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(
      getDomains.pending, (state, action) => {
        state.domains = [];
        state.loading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      getDomains.fulfilled, (state, { payload  }) => {
        state.domains = payload.domains;
        state.loading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getDomains.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getTaskTypesMotivationsForDomain.pending, (state, action) => {
        state.taskTypesMotivations = [];
        state.loading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      getTaskTypesMotivationsForDomain.fulfilled, (state, { payload  }) => {
        state.taskTypesMotivations = payload;
        state.loading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getTaskTypesMotivationsForDomain.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getTaskTypesForDomain.pending, (state, action) => {
        state.taskTypes = [];
        state.loading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      getTaskTypesForDomain.fulfilled, (state, { payload  }) => {
        state.taskTypes = payload.domaintasktypes;
        state.loading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getTaskTypesForDomain.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.loading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getDomainMembersForDomain.pending, (state, action) => {
        state.members = [];
        state.membersLoading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      getDomainMembersForDomain.fulfilled, (state, { payload  }) => {
        state.members = payload.domainMembers;
        state.membersLoading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getDomainMembersForDomain.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.membersLoading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getWorkgroups.pending, (state, action) => {
        state.workgroups = [];
        state.workgroupsLoading = "loading";
        state.currentRequestId = action.meta.requestId
      }
    );
    builder.addCase(
      getWorkgroups.fulfilled, (state, { payload  }) => {
        state.workgroups = payload.workgroups;
        state.workgroupsLoading = "loaded";
        state.currentRequestId = undefined;
      }
    );
    builder.addCase(
      getWorkgroups.rejected,(state, action) => {
        if(action.meta && !action.meta.aborted) {
          state.workgroupsLoading = "error";
        }
        state.error = action.error.message;
        state.currentRequestId = undefined;
      }
    );
  }
})

export default taskSlice.reducer
